<script setup lang="ts">
    import { IonApp, IonRouterOutlet } from '@ionic/vue';
    import { onMounted } from 'vue';
    import { LoadingProvider } from './components/ui/feedback';
    import FraudAlertModal from './components/ui/modals/FraudAlertModal.vue';
    import MobileSidePanel from './components/ui/navigation/MobileSidePanel.vue';
    import { useAppInit } from './composables/useAppInit';
    import { useAuthStore } from './store/auth';

    const { initializeApp } = useAppInit();
    const authStore = useAuthStore();

    onMounted(async () => {
        await initializeApp();
    });
</script>

<template>
    <ion-app>
        <loading-provider />

        <fraud-alert-modal />

        <mobile-side-panel v-if="authStore.isAuthenticated && !authStore.isInVerificationProcess" />

        <ion-router-outlet
            id="main-content"
            animated="false"
        ></ion-router-outlet>
    </ion-app>
</template>
